import React, { useState, useEffect } from 'react';
import parse from 'html-react-parser';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import "../../../node_modules/react-datepicker/dist/react-datepicker.css";
import $ from 'jquery';

import Loginheader from '../Loginheader';
import Menu from '../Menu';

import * as Common from '../Common';
import Dialog from '../Dialog';

function UploadBankRefNo() {
    const navigate = useNavigate();

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);

    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'UPLOADBANKREFNO'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {

                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    function btnUploadFile() {
        $('.loader').show();
        var tempArray = document.getElementById('fileToUpload').files[0].name.split('.');

        if (tempArray.length > 2) {
            $('.loader').hide();
            setMsgText("(.) not allowed in file name.");
            setMsgBox(true);
        } else if (document.getElementById('fileToUpload').files[0] === undefined) {
            $('.loader').hide();
            setMsgText("Please select a file to upload.");
            setMsgBox(true);
        } else if (document.getElementById('fileToUpload').files[0].size > 10 * 1024 * 1024) {  // 10 MB
            $('.loader').hide();
            setMsgText("Please select a file with in 10 MB size.");
            setMsgBox(true);
        } else {
            var object1 = {
                sid: sid,
                uploadType: 'UPLOADBANKREFNO',
                srno: 0,
                pageright: 'UPLOADBANKREFNO',
                docid: 0,
                remark: ''
            }

            Common.uploadApi(JSON.stringify(object1), 'fileToUpload', function (result) {
                console.log(result);
                let resp = JSON.parse(result);

                $('.loader').hide();
                if (resp.error === "") {
                    alert(resp.message);
                }
            });
        }
    }


    return (
        <>
            <Loginheader></Loginheader>
            <Menu></Menu>
            <Container fluid >
                <Row>
                    <Col>
                        <h1>Upload TT Bank Reference </h1>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group controlId='fileToUpload'>
                            <Form.Label>File (Max 10MB)</Form.Label>
                            <Form.Control type="file"></Form.Control>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.Label>&nbsp;</Form.Label><br></br>
                            <Button variant="outline-success" size="sm" onClick={(e) => btnUploadFile()} >Upload</Button>
                        </Form.Group>
                    </Col>
                    <Col>&nbsp;</Col><Col>&nbsp;</Col>
                </Row>
            </Container>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
        </>
    )
}
export default UploadBankRefNo;